import { Injectable }       from '@angular/core';
import { NgbModal }         from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';

import { ApiService }                  from '../api/api.service';
import { CapricornCreateCsvComponent } from './capricorn.create-csv.component';
import { CompanyIntegrationsModel }    from '../companies/models/company.integrations';
import { SessionService }              from '../sessions/session.service';

@Injectable({
  providedIn: 'root'
})
export class CapricornService {
  public title = this.translateService.instant('COMPANY_SPACE.INTEGRATIONS.CAPRICORN.CAPRICORN');

  constructor (
    private apiService      : ApiService,
    private modalService    : NgbModal,
    private sessionService  : SessionService,
    private translateService: TranslateService
  ) {}

  activate () : Promise<any> {
    return this.apiService.get('/company_integrations/add_capricorn')
      .then(() => this.sessionService.refresh());
  }

  createCsv ( integrations ?: CompanyIntegrationsModel ) : Promise<any> {
    const modal = this.modalService.open(CapricornCreateCsvComponent);

    modal.componentInstance.integrations = integrations;

    return modal.result;
  }

  deactivate () : Promise<any> {
    return this.apiService.get('/company_integrations/remove_capricorn')
      .then(() => this.sessionService.refresh());
  }

  downloadCsv ( startDate : string, endDate : string ) : void {
    window.open(`${
      this.apiService.getEndpoint()
    }/capricorn/download_csv/${
      startDate
    }/${
      endDate
    }`);
  }

  getSettings () : Promise<CompanyIntegrationsModel> {
    return this.apiService.get('/company_integrations');
  }

  saveSettings ( integrations : CompanyIntegrationsModel ) : Promise<any> {
    return this.apiService.patch('/company_integrations', integrations, 'company_integration');
  }
}
